import {Divider} from "@nextui-org/react";
import {Switch} from "@nextui-org/switch";
import {PlusIcon} from "@heroicons/react/24/solid";
import * as React from "react";
import {useBusinessPolicies} from "./useBusinessPolicies";
import {FadeInSlide} from "app/motions/fadeInSlide";
import {InputEdit} from "app/components/inputEdit/InputEdit";
import {Icon} from "@subframe/core";
import {AsButton, reactSelectStyles} from "app/subframe";
import Select from "react-select";
import {UpgradeBanner} from "app/billing/components/upgradeBanner";
import {useState} from "react";
import {TextAreaEdit} from "../../components/textAreaEdit/TextAreaEdit";

export interface BusinessPoliciesProps {
}

export const BusinessPolicies: React.FC<BusinessPoliciesProps> = (props) => {
    const {
        account,
        onUpdateAccount,
        uploadWaiver,
        onDownloadWaiver,
        uploadConsent,
        onDownloadConsent,
        consentServices,
        onHandleConsentServiceChange,
    } = useBusinessPolicies();
    const {paywallPermissions} = account;


    const [consentWaiverText, setConsentWaiverText] = useState('I acknowledge that I have been informed of the nature of the treatment, potential risks, benefits, and alternatives. I understand that no guarantee has been made regarding the outcome of the treatment. I consent to the treatment and release the practitioner and facility from any liability.');

    return (


        <div className="space-y-6">
            {/*<div>*/}
            {/*    <h4 className="text-base font-medium text-gray-900 mb-4">Marketing policies</h4>*/}
            {/*    <div className={'space-y-4'}>*/}
            {/*        <div className="p-4 border border-gray-200 rounded-lg">*/}
            {/*            /!*<div className="flex flex-col gap-4 mt-4 mb-6">*!/*/}
            {/*            /!*    {!paywallPermissions?.reviewLink && (*!/*/}
            {/*            /!*        <UpgradeBanner text={"Your plan doesn't include this feature."}/>)}*!/*/}
            {/*            /!*</div>*!/*/}
            {/*            <div className="flex flex-col gap-6">*/}
            {/*                <div className="flex gap-16 items-start">*/}
            {/*                    <div className="flex flex-col gap-1">*/}
            {/*                        <p className="text-neutral-900">Request a review</p>*/}
            {/*                        <p className="text-sm text-neutral-500">*/}
            {/*                            Send a thank-you email half hour post-appointment to request a*/}
            {/*                            review, encouraging customers to share their experience on*/}
            {/*                            Google, Yelp, or the platform of your choice.*/}
            {/*                        </p>*/}
            {/*                    </div>*/}
            {/*                    <Switch*/}
            {/*                        className={'text-blue-700'}*/}
            {/*                        size="sm"*/}
            {/*                        defaultSelected={account.requestReview}*/}
            {/*                        onChange={(event) => onUpdateAccount({*/}
            {/*                            requestReview: event.target.checked,*/}
            {/*                        })}*/}
            {/*                        // isDisabled={!paywallPermissions?.reviewLink}*/}
            {/*                    />*/}
            {/*                </div>*/}
            {/*                {account.requestReview && (<FadeInSlide direction="top">*/}
            {/*                    <div*/}
            {/*                        className="flex w-full flex-col items-start gap-4 rounded-md border border-solid border-neutral-100 bg-neutral-0 px-3 py-4">*/}
            {/*                        <div className="flex flex-col gap-1 w-full">*/}
            {/*                            <InputEdit*/}
            {/*                                defaultValue={account.reviewLink || ""}*/}
            {/*                                name="reviewLink"*/}
            {/*                                label="Your review link"*/}
            {/*                                isEditing={account.reviewLink === ""}*/}
            {/*                                valueClassName="text-body-bold font-body-bold text-neutral-900"*/}
            {/*                                onSave={(value) => {*/}
            {/*                                    if (value?.reviewLink !== "") {*/}
            {/*                                        onUpdateAccount(value);*/}
            {/*                                    }*/}
            {/*                                }}*/}
            {/*                                truncateLength={48}*/}
            {/*                            />*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    {account.reviewLink === "" && (<p className="text-sm text-error-600 font-medium mt-4">*/}
            {/*                        Please note: To activate this feature, please enter your*/}
            {/*                        review link.*/}
            {/*                    </p>)}*/}
            {/*                </FadeInSlide>)}*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*    </div>*/}


            {/*</div>*/}
            {/*<div>*/}
            {/*    <h4 className="text-base font-medium text-gray-900 mb-4">Consent policies</h4>*/}
            {/*    <div className={'space-y-4'}>*/}
            {/*        <div className="p-4 border border-gray-200 rounded-lg">*/}
            {/*            <div className="flex flex-col gap-6">*/}
            {/*                <div className="flex gap-16 items-start">*/}
            {/*                    <div className="flex flex-col gap-1">*/}
            {/*                        <p className="text-neutral-900">Request a consent</p>*/}
            {/*                        <p className="text-sm text-neutral-500">*/}
            {/*                            Require customers to check an 'I consent' box to complete your*/}
            {/*                            consent form before their booking is confirmed. This process*/}
            {/*                            complies with the E-Sign Act, ensuring legally valid electronic*/}
            {/*                            consent.*/}
            {/*                        </p>*/}
            {/*                    </div>*/}
            {/*                    <Switch*/}
            {/*                        className={'text-blue-700'}*/}
            {/*                        size="sm"*/}
            {/*                        defaultSelected={account.consentEnabled}*/}
            {/*                        onChange={(event) => onUpdateAccount({*/}
            {/*                            consentEnabled: event.target.checked,*/}
            {/*                        })}*/}
            {/*                    />*/}
            {/*                </div>*/}
            {/*                {account.consentEnabled && (<FadeInSlide direction="top">*/}
            {/*                    <div className="flex gap-16 items-start mb-2">*/}
            {/*                        <div className="flex flex-col gap-1">*/}
            {/*                            <p className="text-neutral-900">Services require consent</p>*/}
            {/*                            <p className="text-sm text-neutral-500">*/}
            {/*                                Select the services for which you'd like to gather user*/}
            {/*                                consent.*/}
            {/*                            </p>*/}
            {/*                            /!* consentServiceIds, setConsentServiceIds *!/*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <Select*/}
            {/*                        key={`select-${consentServices.length}`} // Use key to force re-render*/}
            {/*                        defaultValue={consentServices.map((service) => ({*/}
            {/*                            value: service.id, label: service.title,*/}
            {/*                        }))}*/}
            {/*                        isMulti*/}
            {/*                        name="services"*/}
            {/*                        onChange={onHandleConsentServiceChange}*/}
            {/*                        options={account.services.map((service) => ({*/}
            {/*                            value: service.id, label: service.title,*/}
            {/*                        }))} // Map account.services into valid options*/}
            {/*                        className="text-sm"*/}
            {/*                        placeholder="Select your services"*/}
            {/*                        classNamePrefix="select"*/}
            {/*                        styles={reactSelectStyles({})}*/}
            {/*                    />*/}
            {/*                    <div className="flex flex-col gap-1">*/}
            {/*                        <Divider className="bg-neutral-50 mt-4 mb-6"/>*/}
            {/*                        <p className="text-neutral-900">Upload your consent form</p>*/}
            {/*                        <p className="text-sm text-neutral-500">*/}
            {/*                            Upload your consent from as a .PDF or .DOC.*/}
            {/*                        </p>*/}
            {/*                        <div className="flex gap-4 items-center mt-4 mb-6">*/}
            {/*                            {account.consentForm?.url && (*/}
            {/*                                <div className="relative group w-[100px] h-[100px]">*/}
            {/*                                    /!* Document Icon *!/*/}
            {/*                                    <div*/}
            {/*                                        className="w-full h-full bg-gray-200 flex items-center justify-center rounded border border-gray-300">*/}
            {/*                                        <Icon name={"FeatherFile"} className="scale-[4]"/>*/}
            {/*                                    </div>*/}

            {/*                                    /!* Hover Overlay *!/*/}
            {/*                                    <div*/}
            {/*                                        className="absolute inset-0 bg-black bg-opacity-50 rounded flex flex-col gap-2 items-center justify-center px-1 opacity-0 group-hover:opacity-100 transition-opacity">*/}
            {/*                                        <a*/}
            {/*                                            href={account.consentForm.url}*/}
            {/*                                            target="_blank"*/}
            {/*                                            rel="noopener noreferrer"*/}
            {/*                                            className="text-neutral-900 text-center font-semibold bg-brand-500 hover:bg-brand-600 px-3 py-1 rounded text-sm w-full"*/}
            {/*                                        >*/}
            {/*                                            View*/}
            {/*                                        </a>*/}
            {/*                                        <AsButton*/}
            {/*                                            text="Download"*/}
            {/*                                            size="xs"*/}
            {/*                                            className="w-full"*/}
            {/*                                            onClick={() => onDownloadConsent(account.consentForm!.id)}*/}
            {/*                                        />*/}
            {/*                                    </div>*/}
            {/*                                    /!* Document Name *!/*/}
            {/*                                    <p className="text-xs text-neutral-900 mt-1 truncate w-full text-center">*/}
            {/*                                        {account.consentForm.name}*/}
            {/*                                    </p>*/}
            {/*                                </div>)}*/}

            {/*                            <input*/}
            {/*                                type="file"*/}
            {/*                                accept=".pdf,.doc,.docx"*/}
            {/*                                onChange={uploadConsent}*/}
            {/*                                className="hidden"*/}
            {/*                                id="consent-upload"*/}
            {/*                            />*/}
            {/*                            <label*/}
            {/*                                htmlFor="consent-upload"*/}
            {/*                                className="flex flex-col gap-3 w-[100px] h-[100px] bg-zinc-100 items-center justify-center border-dashed border-2 p-[10px] rounded cursor-pointer"*/}
            {/*                            >*/}
            {/*                                <PlusIcon className="h-5 w-5 stroke-black"/>*/}
            {/*                                <p className="text-sm">Upload</p>*/}
            {/*                            </label>*/}
            {/*                        </div>*/}
            {/*                        {!account.consentForm?.url && (<p className="text-sm text-error-600 font-medium">*/}
            {/*                            Please note: To activate this feature, please upload a*/}
            {/*                            consent document in .PDF or .DOC format.*/}
            {/*                        </p>)}*/}
            {/*                    </div>*/}
            {/*                </FadeInSlide>)}*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div>*/}
            {/*    <h4 className="text-base font-medium text-gray-900 mb-4">Waiver policies</h4>*/}
            {/*    <div className={'space-y-4'}>*/}
            {/*        <div className="p-4 border border-gray-200 rounded-lg">*/}

            {/*            <div className="flex flex-col gap-6">*/}
            {/*                <div className="flex gap-16 items-center justify-between">*/}
            {/*                    <div className="flex flex-col gap-1">*/}
            {/*                        <p className="text-neutral-900">Request a waiver</p>*/}
            {/*                        <p className="text-sm text-neutral-500">*/}
            {/*                            Request customers to complete your waiver after{" "}*/}
            {/*                            <span className="font-bold">their first booking</span>. An email*/}
            {/*                            will be sent with instructions.*/}
            {/*                        </p>*/}
            {/*                    </div>*/}
            {/*                    <Switch*/}
            {/*                        className={'text-blue-700'}*/}
            {/*                        size="sm"*/}
            {/*                        defaultSelected={account.waiverEnabled}*/}
            {/*                        onChange={(event) => onUpdateAccount({*/}
            {/*                            waiverEnabled: event.target.checked,*/}
            {/*                            waiverRequiredForEveryBooking: !event.target.checked ? false : account.waiverRequiredForEveryBooking,*/}
            {/*                        })}*/}
            {/*                    />*/}
            {/*                </div>*/}
            {/*                {account.waiverEnabled && (<FadeInSlide direction="top">*/}
            {/*                    <div className="flex gap-16 items-center justify-between">*/}
            {/*                        <div className="flex flex-col gap-1">*/}
            {/*                            <p className="text-neutral-900">*/}
            {/*                                Request a waiver for every booking*/}
            {/*                            </p>*/}
            {/*                            <p className="text-sm text-neutral-500">*/}
            {/*                                Request customers to complete a waiver with every booking.*/}
            {/*                            </p>*/}
            {/*                        </div>*/}
            {/*                        <Switch*/}
            {/*                            className={'text-blue-700'}*/}
            {/*                            size="sm"*/}
            {/*                            defaultSelected={account.waiverRequiredForEveryBooking}*/}
            {/*                            onChange={(event) => onUpdateAccount({*/}
            {/*                                waiverRequiredForEveryBooking: event.target.checked,*/}
            {/*                            })}*/}
            {/*                        />*/}
            {/*                    </div>*/}
            {/*                    <div className="flex flex-col gap-1">*/}
            {/*                        <Divider className="bg-neutral-50 mt-4 mb-6"/>*/}
            {/*                        <p className="text-neutral-900">Upload your waiver</p>*/}
            {/*                        <p className="text-sm text-neutral-500">*/}
            {/*                            Upload your waiver as a .PDF or .DOC.*/}
            {/*                        </p>*/}
            {/*                        <div className="flex gap-4 items-center mt-4 mb-6">*/}
            {/*                            {account.waiver && (<div className="relative group w-[100px] h-[100px]">*/}
            {/*                                /!* Document Icon *!/*/}
            {/*                                <div*/}
            {/*                                    className="w-full h-full bg-gray-200 flex items-center justify-center rounded border border-gray-300">*/}
            {/*                                    <Icon name={"FeatherFile"} className="scale-[4]"/>*/}
            {/*                                </div>*/}

            {/*                                /!* Hover Overlay *!/*/}
            {/*                                <div*/}
            {/*                                    className="absolute inset-0 bg-black bg-opacity-50 rounded flex flex-col gap-2 items-center justify-center px-1 opacity-0 group-hover:opacity-100 transition-opacity">*/}
            {/*                                    <a*/}
            {/*                                        href={account.waiver.url}*/}
            {/*                                        target="_blank"*/}
            {/*                                        rel="noopener noreferrer"*/}
            {/*                                        className="text-neutral-900 text-center font-semibold bg-brand-500 hover:bg-brand-600 px-3 py-1 rounded text-sm w-full"*/}
            {/*                                    >*/}
            {/*                                        View*/}
            {/*                                    </a>*/}
            {/*                                    <AsButton*/}
            {/*                                        text="Download"*/}
            {/*                                        size="xs"*/}
            {/*                                        className="w-full"*/}
            {/*                                        onClick={() => onDownloadWaiver(account.waiver!.id)}*/}
            {/*                                    />*/}
            {/*                                </div>*/}
            {/*                                /!* Document Name *!/*/}
            {/*                                <p className="text-xs text-neutral-900 mt-1 truncate w-full text-center">*/}
            {/*                                    {account.waiver.name}*/}
            {/*                                </p>*/}
            {/*                            </div>)}*/}

            {/*                            <input*/}
            {/*                                type="file"*/}
            {/*                                accept=".pdf,.doc,.docx"*/}
            {/*                                onChange={uploadWaiver}*/}
            {/*                                className="hidden"*/}
            {/*                                id="waiver-upload"*/}
            {/*                            />*/}
            {/*                            <label*/}
            {/*                                htmlFor="waiver-upload"*/}
            {/*                                className="flex flex-col gap-3 w-[100px] h-[100px] bg-zinc-100 items-center justify-center border-dashed border-2 p-[10px] rounded cursor-pointer"*/}
            {/*                            >*/}
            {/*                                <PlusIcon className="h-5 w-5 stroke-black"/>*/}
            {/*                                <p className="text-sm">Upload</p>*/}
            {/*                            </label>*/}
            {/*                        </div>*/}
            {/*                        {!account.waiver && (<p className="text-sm text-error-600 font-medium">*/}
            {/*                            Please note: To activate this feature, please upload a*/}
            {/*                            waiver document in .PDF or .DOC format.*/}
            {/*                        </p>)}*/}
            {/*                    </div>*/}
            {/*                </FadeInSlide>)}*/}
            {/*            </div>*/}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

                <div className="space-y-6">
                    {/* Cancellation Policy */}
                    <div>
                        <h4 className="text-base font-medium text-gray-900 mb-4">Cancellation Policy</h4>
                        <div className="space-y-4">
                            <div className="p-4 border border-gray-200 rounded-lg">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Cancellation Policy Text
                                    </label>
                                    {/*<textarea*/}
                                    {/*    rows={4}*/}
                                    {/*    defaultValue="Appointments must be cancelled at least 24 hours in advance. Late cancellations or no-shows will be charged 50% of the service fee. We understand emergencies happen - please contact us to discuss your situation."*/}
                                    {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
                                    {/*/>*/}

                                    <TextAreaEdit
                                        defaultValue={account?.cancellationPolicy}
                                        // label="Cancellation Policy"
                                        name="cancellation_policy"
                                        onSave={(value) => onUpdateAccount({ ...value })}
                                        valueClassName="text-body-bold font-body-bold text-neutral-900"
                                        truncateLength={1000}
                                    />


                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Consent/Waiver Toggle */}
                    <div>
                        <h4 className="text-base font-medium text-gray-900 mb-4">Consent & Waiver</h4>
                        <div className="space-y-4">
                            <div className="p-4 border border-gray-200 rounded-lg">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <h5 className="text-sm font-medium text-gray-900">Require Consent/Waiver</h5>
                                        <p className="text-sm text-gray-500 mt-1">Require clients to sign consent forms and waivers before treatments</p>
                                    </div>
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            className="sr-only peer"
                                            // checked={consentWaiverEnabled}
                                            // onChange={(e) => setConsentWaiverEnabled(e.target.checked)}
                                            checked={account.consentEnabled}
                                            onChange={(event) => onUpdateAccount({
                                                consentEnabled: event.target.checked,
                                            })}

                                        />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                    </label>
                                </div>
                                {account.consentEnabled && (
                                    <div className="mt-4 pt-4 border-t border-gray-200">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Consent & Waiver Text
                                        </label>

                                        <TextAreaEdit
                                            defaultValue={account?.consentText}
                                            // label="Cancellation Policy"
                                            name="consent_text"
                                            onSave={(value) => onUpdateAccount({ ...value })}
                                            valueClassName="text-body-bold font-body-bold text-neutral-900"
                                            truncateLength={1000}
                                        />
                                        {/*<textarea*/}
                                        {/*    rows={4}*/}
                                        {/*    value={consentWaiverText}*/}
                                        {/*    onChange={(e) => setConsentWaiverText(e.target.value)}*/}
                                        {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
                                        {/*    placeholder="Enter the consent and waiver text that clients will need to agree to..."*/}
                                        {/*/>*/}

                                        <p className="text-xs text-gray-500 mt-1">
                                            This text will be presented to clients before treatments for their agreement and signature.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>



        </div>


    );
};
